<template>
    <LayoutLogin>
        <div class="pb-13 pt-lg-0 pt-5">
            <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
                <template v-if="sendMail">パスワード再設定依頼 (完了)</template>
                <template v-else="sendMail">パスワード再設定</template>
            </h3>
        </div>

        <div v-if="sendMail">
            <div class="border p-5">
                <h5><b>パスワード再設定のメールを送信します。</b></h5>
                <h5><b>メールに記載されたリンクをクリックして手続きを行ってください。</b></h5>
                <br>
                <h5>メールが届かない場合、迷惑メールフォルダーなどもご確認ください。</h5>
            </div>
            <div class="d-flex justify-content-center mt-20">
                <el-button class="pl-15 pr-15" type="primary" @click="$router.push('login')">ログイン画面へ</el-button>
            </div>
        </div>

        <div v-else>
            <el-form :model="form" status-icon :rules="rules" ref="form" label-position="top" >
                <div class="form-group">
                    <label class="font-size-h6 font-weight-bolder text-dark"><span class="text-danger">*</span>メールアドレス</label>
                    <el-form-item prop="email">
                        <el-input type="text" class="input-login" v-model.lazy="form.email" />
                    </el-form-item>
                </div>

                <div class="d-flex justify-content-center mt-0">
                    <el-button class="btn-custom" type="" @click="$router.push('login')">
                        キャンセル
                    </el-button>
                    <el-button class="btn-custom" type="primary" @click="onSubmit">
                        確定
                    </el-button>
                </div>
                <input type="hidden" name="_csrf" v-model="form._csrf" />
            </el-form>
        </div>
    </LayoutLogin>

</template>

<script>
import { mapState, mapMutations } from "vuex";
import apiService from "@/core/services/api.service";
import { getCsrfRandom } from "@/core/services/store/auth.module";
import LayoutLogin from "@/view/pages/auth/Layout"
import { SET_LOADING, NOT_LOADING } from "@/core/services/store/htmlclass.module";
import routeTenant from "@/core/services/routeTenant.service";
const tenant = routeTenant.getTenant();

export default {
    name: "ForgotPassword",
    components: {
        LayoutLogin
    },
    data() {
        return {
            loading: false,
            form: {
                tenant_code: tenant,
                email: "",
                _csrf: "",
            },
            rules: {},
            sendMail: false,
        };
    },
    watch: {
        "form.email": function () {
            this.form.email = this.form.email.replace(/\s+/g, "");
        },
    },
    mounted() {
  },
    computed: {
        ...mapState({
            errors: (state) => state.auth.errors,
        }),
    },
    
    created() {
        this.form._csrf = getCsrfRandom();
        this.form.tenant_code = this.$route.params.tenant;
        this.form.form_url = this.$route.params.form_url;
    },

    methods: {
        ...mapMutations([SET_LOADING, NOT_LOADING]),
        onSubmit() {
            this[SET_LOADING]()
            this.$refs["form"].clearValidate()

            this.$refs["form"].validate((valid) => {
                if (!valid) return;
                this.turnOffErrorMessage("form");
                let data = JSON.parse(JSON.stringify(this.form));
                apiService
                    .post(`user/auth/forgot-password`, data)
                    .then((res) => {
                        if (res && res.data && res.data.success) {
                            this.sendMail = true;
                        } else {
                            this.showErrorMessage(res.data.data, "form");
                        }
                        this[NOT_LOADING]()
                    })
                    .catch((e) => {
                        console.error(`======= `, { e });
                        console.trace();
                        this[NOT_LOADING]()
                    });
            });
        },
    },
};
</script>
